import React from 'react';

const sizeClasses = {
  sm: {
    mark: 'h-8',
    word: 'h-[15px]',
    gap: 'gap-2.5',
  },
  md: {
    mark: 'h-9',
    word: 'h-[18px]',
    gap: 'gap-3',
  },
};

export default function ArclipseBrandLockup({ size = 'md', className = '' }) {
  const classes = sizeClasses[size] || sizeClasses.md;

  return (
    <span className={`inline-flex items-center ${classes.gap} ${className}`}>
      <img
        src="/assets/arclipse-emblem.png"
        alt=""
        className={`${classes.mark} w-auto shrink-0 object-contain`}
      />
      <img
        src="/assets/arclipse-wordmark.png"
        alt="Arclipse"
        className={`${classes.word} w-auto object-contain`}
      />
    </span>
  );
}
